import { Box } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { useTemplate } from '../../../../hooks';
import useLandingChart from '../../../../hooks/useLandingChart';
import { userroles } from '../../../constants';
import { qtyFormat, getColor } from '../../common/helpers';
import InfoBox from '../InfoBox';

function TodayTotalEvents({
  isRTL,
  theme,
  dark,
  color,
  systemcolor,
  height,
  employeeId = null,
  isEmployee = false,
}) {
  const { eventsTodayCount } = useLandingChart(employeeId);
  const clr = getColor({ theme, color, systemcolor });
  const { tempwords } = useTemplate();
  const navigate = useNavigate();

  return (
    <Box>
      {(isEmployee || userroles?.operations?.admin) && (
        <Box
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/appointments')}
        >
          <InfoBox
            title={
              isRTL
                ? `${tempwords?.appointments} اليوم`
                : `${tempwords?.appointments} Today`
            }
            desc={''}
            value={qtyFormat(eventsTodayCount)}
            icon="sales"
            color={clr}
            dark={dark}
            height={height}
          ></InfoBox>
        </Box>
      )}
    </Box>
  );
}

export default TodayTotalEvents;
